// Side margins for the site's max-w-screen-lg sections between 768 and
// 1023 px (tablets, a foldable's inner screen), where they used to run edge
// to edge. Phones keep each section's own margin, and from 1024 px the box is
// centred with no padding, as before.

/** A section without its own background: the gutter is padding. */
export const SECTION_GUTTER = "md:mx-auto md:w-full md:px-8 lg:px-0";

/** A section that draws its own background or border: the gutter is margin. */
export const BOXED_SECTION_GUTTER =
  "md:mx-8 md:w-[calc(100%-4rem)] lg:mx-auto lg:w-full";

/** Footnotes: one readable measure, centred, from 600 px up to 1023 px. */
export const TABLET_PROSE =
  "min-[600px]:max-lg:mx-auto min-[600px]:max-lg:max-w-prose min-[600px]:max-lg:text-center";
